import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SubmitLockingCabinetDetails, fetchInitialState, updateLockingCabinetOption } from './lockingCabinetSlice';
// import CabinetImage from '../../img/fileCabinet.png'
import { BACKEND_API_URL } from '../../config';
import Loader from '../../components/loader';
import { OptionCard, OptionCardRow, OptionCardSeparator, StepHeading, StepShell } from '../../components/optionCard';

const LockingCabinetDetails = () => {
    const lockingCabinetDetailsState = useSelector(state => state.locking_cabinet);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchInitialState())
    }, [dispatch])

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            // Handle file selection via input
            let uploadedFile = e.target.files[0];
            dispatch(SubmitLockingCabinetDetails({ ...lockingCabinetDetailsState.data, '_image': uploadedFile }));

        } else if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            // Handle file drop
            let uploadedFile = e.dataTransfer.files[0];
            dispatch(SubmitLockingCabinetDetails({ ...lockingCabinetDetailsState.data, '_image': uploadedFile }));
        }
        e.target.value = null;
    }

    const handleDelete = (e) => {
        e.preventDefault()
        dispatch(SubmitLockingCabinetDetails({ ...lockingCabinetDetailsState.data, '_image': 'delete' }))
    
      };
    
    const handleDownload = (e) => {
      e.preventDefault()
      const url = `${BACKEND_API_URL}/api/files/download?path=${encodeURIComponent(lockingCabinetDetailsState.data._image)}`;
        fetch(url)
          .then(response => response.blob())
          .then(blob => {
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.style.display = 'none';
              a.href = url;
              // Specify a filename for the downloaded file
              a.download = lockingCabinetDetailsState.data._image.split("/").pop();
              document.body.appendChild(a);
              a.click();
              window.URL.revokeObjectURL(url);
          })
          .catch(err => console.error('Fetch error:', err));
    };

    return (
    <>
        { lockingCabinetDetailsState.loading && <Loader /> }
        <StepShell>
            <StepHeading>
                Do you have a locking file cabinet?
            </StepHeading>

            <OptionCardRow>
                {/* Yes Option */}
                <OptionCard
                    selected={lockingCabinetDetailsState.data._option === 'Yes'}
                    onClick={() => dispatch(updateLockingCabinetOption('Yes'))}
                >
                    Yes
                </OptionCard>

                <OptionCardSeparator />

                {/* No Option */}
                <OptionCard
                    selected={lockingCabinetDetailsState.data._option === 'No'}
                    onClick={() => dispatch(updateLockingCabinetOption('No'))}
                >
                    No
                </OptionCard>
            </OptionCardRow>

            { lockingCabinetDetailsState.data._option === 'Yes' && ((lockingCabinetDetailsState.data._image && lockingCabinetDetailsState.data._image !== 'null') ? (
                                <div className="mb-4 mt-10 grid w-full max-w-md grid-cols-3 items-center justify-between gap-2 rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
                                        <p className="col-span-2 truncate text-sm font-semibold text-[#211b4f]">
                                            {lockingCabinetDetailsState.data._image.split("/").pop()}
                                        </p>
                                        <div className="col-span-1 flex justify-end">
                                            <button
                                                onClick={handleDownload}
                                                className="inline-flex h-9 w-9 items-center justify-center rounded-lg fill-current text-[#211b4f] transition-colors hover:bg-[#211b4f]/5"
                                            >
                                                {/* <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-down-circle" viewBox="0 0 16 16">
                                                    <path fillRule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293z"/>
                                                </svg> */}
                                                <svg xmlns="http://www.w3.org/2000/svg" height="26" viewBox="0 0 24 24" width="26">
                                                    <path d="M0 0h24v24H0z" fill="none"/>
                                                    <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
                                                </svg>
                                            </button>
                                            <button
                                                onClick={handleDelete}
                                                className="inline-flex h-9 w-9 items-center justify-center rounded-lg text-red-600 transition-colors hover:bg-red-50"
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16">
                                                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/>
                                                    <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"/>
                                                </svg>
                                            </button>
                                    </div>
                                </div>
                            ) : (
                                <div className="mt-10 flex w-full max-w-md items-center justify-center"
                                    onDragOver={(e) => {e.preventDefault(); e.stopPropagation()}}
                                    onDragEnter={(e) => {e.preventDefault(); e.stopPropagation()}}
                                    onDragLeave={(e) => {e.preventDefault(); e.stopPropagation()}}
                                    onDrop={(e) => { e.preventDefault(); e.stopPropagation(); handleFileChange(e)}}
                                    >
                                    <label htmlFor="dropzone_file" className="flex w-full cursor-pointer flex-col items-center justify-center rounded-2xl border-2 border-dashed border-slate-300 bg-slate-50 transition-colors hover:border-[#fb6635] hover:bg-orange-50">
                                        <div className="flex flex-col items-center justify-center pt-5 pb-6">
                                            <svg className="w-8 h-8 mb-4 text-gray-500 " aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
                                                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"/>
                                            </svg>
                                            <p className="mb-2 text-sm text-gray-500 "><span className="font-semibold">Click to upload a picture of the</span> </p>
                                            <p className="mb-2 text-sm text-gray-500 "><span className="font-semibold">file cabinet in your office.</span> </p>
                                            <p className="mb-2 text-sm text-gray-500 ">or drag and drop</p>
                                        </div>
                                        <input name='_image' onChange={handleFileChange} id="dropzone_file" type="file" className="hidden" />
                                    </label>
                                </div> 
                            ))}


            {/* <img className={`${lockingCabinetDetailsState.data._option === 'Yes' ? 'mt-4' : 'mt-14'}`} src={CabinetImage} height={200} alt='file cabinet'/> */}
        </StepShell>
    </>
  )
}

export default LockingCabinetDetails;
